import { BrowserConsoleSubscriber, type FilterFn, SubscriberBuilder } from "@artis/logger/subscribers";
import type { Subscriber } from "@artis/logger";

import { getDeploymentEnv } from "./integrations";

let DEBUG_LOG_TAGS: string[] = [];
const debugLogTagFilter: FilterFn = (event) => {
  if (event.level === "debug" && DEBUG_LOG_TAGS.length === 0) return false;
  if (event.level !== "debug") return true;
  const evTags = Array.isArray(event.fields.tags) ? event.fields.tags : [];
  return DEBUG_LOG_TAGS.some((tag) => evTags.includes(tag));
};

const logSubscriber = new SubscriberBuilder()
  .withMinLevel("debug")
  .withSubscriber(new BrowserConsoleSubscriber({ performance: getDeploymentEnv() !== "prod" }), debugLogTagFilter);

export const setDebugLogTags = (tags: string[]) => {
  DEBUG_LOG_TAGS = tags;
};
export const addLogSubscriber = (subscriber: Subscriber) => logSubscriber.withSubscriber(subscriber, debugLogTagFilter);

logSubscriber.install();
